import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: TipsState = {
    all: [],
    viewing: undefined,
};

const rootState: TipsState = initialState;

const getters: GetterTree<TipsState, RootState> = {
    all(state: TipsState): Tip[] | undefined {
        return state.all;
    },
    spotlight(state: TipsState): Tip | undefined {
        return state.all.find((tip: Tip) => tip.spotlight);
    },
    viewing(state: TipsState): Tip | undefined {
        return state.viewing;
    },
};

const mutations: MutationTree<TipsState> = {
    RESET(state: TipsState) {
        state.all = [];
    },
    SET_TIPS(state: TipsState, payload: Tip[]) {
        state.all = payload;
    },
    SET_VIEWING_TIP(state: TipsState, payload: Tip) {
        state.viewing = payload;
    },
    DELETE_TIP(state: TipsState, payload: { id: number }) {
        if (state.all) {
            state.all = state.all.filter((tip: Tip) => tip.id !== payload.id);
        }
    },
};

const actions: ActionTree<TipsState, RootState> = {
    clearViewingTip({ commit, state }): any {

        commit('SET_VIEWING_TIP', undefined);

        return new Promise((resolve) => resolve(undefined));
    },
    create({ commit, state }, payload: Tip): any {

        // @ts-ignore
        return this._vm.$api.post(`tips`, payload, { withCredentials: true })
            .then((response: { data: Tip }) => {
                const tip: Tip = response.data;

                return Promise.resolve(tip);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    index({ commit }): any {
        // @ts-ignore
        return this._vm.$api.get(`tips`, { withCredentials: true })
            .then((response: { data: Tip[] }) => {
                const tips: Tip[] = response.data;

                commit('SET_TIPS', tips);

                return Promise.resolve(tips);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    read({ commit, state }, payload: number): any {
        const viewing = state.all.find((tip: Tip) => tip.id === payload);
        if (viewing) {
            commit('SET_VIEWING_TIP', viewing);

            return new Promise((resolve) => resolve(viewing));
        }

        // @ts-ignore
        return this._vm.$api.get(`tips/${payload}`, { withCredentials: true })
            .then((response: { data: Tip }) => {
                const tip: Tip = response.data;

                commit('SET_VIEWING_TIP', tip);

                return Promise.resolve(tip);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    search({ commit, state }, payload: { slug?: string, show_in_overview?: boolean, exclude_id?: number }): any {

        // @ts-ignore
        return this._vm.$api.get(`tips/search`, { params: payload, withCredentials: true })
            .then((response: { data: Tip[] }) => {
                const tips: Tip[] = response.data;

                commit('SET_TIPS', tips);

                return Promise.resolve(tips);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    spotlight({ commit, state }): any {
        // @ts-ignore
        return this._vm.$api.get(`tips/spotlight`, { withCredentials: true })
            .then((response: { data: Tip[] }) => {
                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    update({ commit, state }, payload: Tip): any {

        // @ts-ignore
        return this._vm.$api.put(`tips/${payload.id}`, payload, { withCredentials: true })
            .then((response: { data: Tip }) => {
                const tip: Tip = response.data;

                return Promise.resolve(tip);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    delete({ commit, state }, payload: { id: number }): any {

        // @ts-ignore
        return this._vm.$api.delete(`tips/${payload.id}`, { withCredentials: true })
            .then((response: { data: Tip }) => {

                commit('DELETE_TIP', payload);

                return Promise.resolve(payload.id);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    indexMock({ commit }, payload?: string): any {
        let queryParams = '';
        if (payload) {
            queryParams = `?category=${payload}`;
        }
        // @ts-ignore
        return this._vm.$mockApi.get(`tips.json${queryParams}`, { withCredentials: true })
            .then((response: { data: Tip[] }) => {
                let tips: Tip[] = response.data;
                if (payload) {
                    tips = tips.filter((tip: Tip) => tip.tags?.includes(payload));
                }

                commit('SET_TIPS', tips);

                return Promise.resolve(tips);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    readMock({ commit, state }, payload: string): any {
        const viewing = state.all.find((tip: Tip) => tip.slug === payload);
        if (viewing) {
            commit('SET_VIEWING_TIP', viewing);
            return new Promise((resolve) => resolve(viewing));
        }

        // @ts-ignore
        return this._vm.$mockApi.get(`tips.json`, { withCredentials: true })
            .then((response: { data: Tip[] }) => {
                let tip;
                if (payload) {
                    tip = response.data.find((t: Tip) => t.slug?.includes(payload));
                }
                commit('SET_VIEWING_TIP', tip);

                return Promise.resolve(tip);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
